var _path, _g, _path2, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEfficientSupportTools(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81485 1.35292C9.33393 0.828208 11.0033 1.64561 11.5335 3.17985L13.7362 9.55314C14.2419 11.0167 13.477 12.6091 12.0279 13.1099L7.37692 14.7173C5.85778 15.2422 4.18848 14.4247 3.65822 12.8904L1.45561 6.51711C0.949834 5.05364 1.71407 3.46156 3.16295 2.96062L7.81485 1.35292Z",
    fill: "url(#paint0_linear_9308_7436)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_9308_7436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3005 11.0586L9.2186 11.4325C8.31131 11.746 7.31348 11.6589 6.47431 11.1927C5.74649 10.7884 5.19357 10.1296 4.92161 9.34274L4.12987 7.05184C3.82681 6.17492 4.25995 5.22961 5.09744 4.94018L7.7855 4.01118C8.66351 3.70774 9.63728 4.2064 9.95501 5.12575L11.2724 8.93751C11.5754 9.81443 11.1413 10.768 10.3005 11.0586Z",
    fill: "#E46800"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 1.66823,
    y: -0.583725,
    width: 19.5417,
    height: 21.4756
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.06px)",
      clipPath: "url(#bgblur_0_9308_7436_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4.12035,
    d: "M17.0042 13.7053C17.0042 15.3503 15.6837 16.6855 14.053 16.6858H8.9729C7.26562 16.6858 5.87427 15.2865 5.87427 13.5637L5.87427 6.61548C5.87427 4.97056 7.20085 3.6225 8.83813 3.62231L13.5774 3.62231L13.6116 3.62915C13.6223 3.63377 13.6318 3.64098 13.6399 3.64966L16.9807 7.24341C16.9955 7.25929 17.0042 7.28032 17.0042 7.302V13.7053Z",
    fill: "#FFCBB9",
    fillOpacity: 0.35,
    stroke: "url(#paint1_linear_9308_7436)",
    strokeWidth: 0.171681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 6.70481,
    y: 6.34715,
    width: 8.94316,
    height: 8.97514
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.29px)",
      clipPath: "url(#bgblur_1_9308_7436_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9308_7436)",
    "data-figma-bg-blur-radius": 2.57522
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_9308_7436",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6311 11.2779H11.6123V12.307C11.6123 12.5509 11.4179 12.7471 11.1764 12.7471C10.935 12.7471 10.7347 12.5509 10.7347 12.307V11.2779H9.72174C9.48027 11.2779 9.28003 11.0816 9.28003 10.8377C9.28003 10.5879 9.48027 10.3916 9.72174 10.3916H10.7347V9.36254C10.7347 9.11866 10.935 8.92236 11.1764 8.92236C11.4179 8.92236 11.6123 9.11866 11.6123 9.36254V10.3916H12.6311C12.8726 10.3916 13.0728 10.5879 13.0728 10.8377C13.0728 11.0816 12.8726 11.2779 12.6311 11.2779Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6311 11.2779H11.6123V12.307C11.6123 12.5509 11.4179 12.7471 11.1764 12.7471C10.935 12.7471 10.7347 12.5509 10.7347 12.307V11.2779H9.72174C9.48027 11.2779 9.28003 11.0816 9.28003 10.8377C9.28003 10.5879 9.48027 10.3916 9.72174 10.3916H10.7347V9.36254C10.7347 9.11866 10.935 8.92236 11.1764 8.92236C11.4179 8.92236 11.6123 9.11866 11.6123 9.36254V10.3916H12.6311C12.8726 10.3916 13.0728 10.5879 13.0728 10.8377C13.0728 11.0816 12.8726 11.2779 12.6311 11.2779Z",
    fill: "url(#paint2_linear_9308_7436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6123 11.2779V11.2092H11.5436V11.2779H11.6123ZM10.7347 11.2779H10.8034V11.2092H10.7347V11.2779ZM10.7347 10.3916V10.4603H10.8034V10.3916H10.7347ZM11.6123 10.3916H11.5436V10.4603H11.6123V10.3916ZM12.6311 11.2779V11.2092H11.6123V11.2779V11.3466H12.6311V11.2779ZM11.6123 11.2779H11.5436V12.307H11.6123H11.6809V11.2779H11.6123ZM11.6123 12.307H11.5436C11.5436 12.5136 11.3793 12.6785 11.1764 12.6785V12.7471V12.8158C11.4565 12.8158 11.6809 12.5881 11.6809 12.307H11.6123ZM11.1764 12.7471V12.6785C10.9723 12.6785 10.8034 12.5124 10.8034 12.307H10.7347H10.6661C10.6661 12.5893 10.8976 12.8158 11.1764 12.8158V12.7471ZM10.7347 12.307H10.8034V11.2779H10.7347H10.6661V12.307H10.7347ZM10.7347 11.2779V11.2092H9.72174V11.2779V11.3466H10.7347V11.2779ZM9.72174 11.2779V11.2092C9.51764 11.2092 9.3487 11.0431 9.3487 10.8377H9.28003H9.21136C9.21136 11.1201 9.4429 11.3466 9.72174 11.3466V11.2779ZM9.28003 10.8377H9.3487C9.3487 10.6258 9.51824 10.4603 9.72174 10.4603V10.3916V10.3229C9.4423 10.3229 9.21136 10.55 9.21136 10.8377H9.28003ZM9.72174 10.3916V10.4603H10.7347V10.3916V10.3229H9.72174V10.3916ZM10.7347 10.3916H10.8034V9.36254H10.7347H10.6661V10.3916H10.7347ZM10.7347 9.36254H10.8034C10.8034 9.15714 10.9723 8.99104 11.1764 8.99104V8.92236V8.85369C10.8976 8.85369 10.6661 9.08018 10.6661 9.36254H10.7347ZM11.1764 8.92236V8.99104C11.3793 8.99104 11.5436 9.15594 11.5436 9.36254H11.6123H11.6809C11.6809 9.08138 11.4565 8.85369 11.1764 8.85369V8.92236ZM11.6123 9.36254H11.5436V10.3916H11.6123H11.6809V9.36254H11.6123ZM11.6123 10.3916V10.4603H12.6311V10.3916V10.3229H11.6123V10.3916ZM12.6311 10.3916V10.4603C12.8346 10.4603 13.0042 10.6258 13.0042 10.8377H13.0728H13.1415C13.1415 10.55 12.9106 10.3229 12.6311 10.3229V10.3916ZM13.0728 10.8377H13.0042C13.0042 11.0431 12.8352 11.2092 12.6311 11.2092V11.2779V11.3466C12.91 11.3466 13.1415 11.1201 13.1415 10.8377H13.0728Z",
    fill: "url(#paint3_linear_9308_7436)",
    mask: "url(#path-4-inside-1_9308_7436)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 10.3059,
    y: 1.93138,
    width: 8.33036,
    height: 8.46513
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.29px)",
      clipPath: "url(#bgblur_2_9308_7436_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_9308_7436)",
    "data-figma-bg-blur-radius": 2.57522
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1683 7.81614C14.6132 7.82065 15.2316 7.82259 15.7562 7.82065C16.0249 7.82001 16.1614 7.49579 15.9751 7.30048C15.3011 6.59273 14.0956 5.32614 13.4057 4.60163C13.2149 4.40117 12.8811 4.53911 12.8811 4.81692V6.51603C12.8811 7.22893 13.4625 7.81614 14.1683 7.81614Z",
    fill: "url(#paint4_linear_9308_7436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9153 4.81714C12.9153 4.56909 13.2125 4.44861 13.3811 4.62573C14.0708 5.35003 15.2769 6.6166 15.9504 7.32397C16.1163 7.49786 15.9941 7.78531 15.7561 7.78589C15.2317 7.78782 14.6129 7.78649 14.1682 7.78198C13.4818 7.78191 12.9155 7.21043 12.9153 6.51636V4.81714Z",
    stroke: "url(#paint5_linear_9308_7436)",
    strokeWidth: 0.0686724
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9308_7436",
    x: 0.771263,
    y: 0.660423,
    width: 13.8596,
    height: 14.2194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.63097,
    result: "effect1_foregroundBlur_9308_7436"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7436_clip_path",
    transform: "translate(-1.66823 0.583725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0042 13.7053C17.0042 15.3503 15.6837 16.6855 14.053 16.6858H8.9729C7.26562 16.6858 5.87427 15.2865 5.87427 13.5637L5.87427 6.61548C5.87427 4.97056 7.20085 3.6225 8.83813 3.62231L13.5774 3.62231L13.6116 3.62915C13.6223 3.63377 13.6318 3.64098 13.6399 3.64966L16.9807 7.24341C16.9955 7.25929 17.0042 7.28032 17.0042 7.302V13.7053Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9308_7436",
    x: 6.70481,
    y: 6.34715,
    width: 8.94316,
    height: 8.97514,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.858405,
    dy: 0.858405
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.858405
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.580392 0 0 0 0 0.247059 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7436",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7436_clip_path",
    transform: "translate(-6.70481 -6.34715)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6311 11.2779H11.6123V12.307C11.6123 12.5509 11.4179 12.7471 11.1764 12.7471C10.935 12.7471 10.7347 12.5509 10.7347 12.307V11.2779H9.72174C9.48027 11.2779 9.28003 11.0816 9.28003 10.8377C9.28003 10.5879 9.48027 10.3916 9.72174 10.3916H10.7347V9.36254C10.7347 9.11866 10.935 8.92236 11.1764 8.92236C11.4179 8.92236 11.6123 9.11866 11.6123 9.36254V10.3916H12.6311C12.8726 10.3916 13.0728 10.5879 13.0728 10.8377C13.0728 11.0816 12.8726 11.2779 12.6311 11.2779Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_9308_7436",
    x: 10.3059,
    y: 1.93138,
    width: 8.33036,
    height: 8.46513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.858405,
    dy: 0.858405
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.858405
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.580392 0 0 0 0 0.247059 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7436",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_9308_7436_clip_path",
    transform: "translate(-10.3059 -1.93138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1683 7.81614C14.6132 7.82065 15.2316 7.82259 15.7562 7.82065C16.0249 7.82001 16.1614 7.49579 15.9751 7.30048C15.3011 6.59273 14.0956 5.32614 13.4057 4.60163C13.2149 4.40117 12.8811 4.53911 12.8811 4.81692V6.51603C12.8811 7.22893 13.4625 7.81614 14.1683 7.81614Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7436",
    x1: 6.13771,
    y1: 1.93255,
    x2: 10.217,
    y2: 13.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7436",
    x1: 7.70451,
    y1: 5.21013,
    x2: 16.1057,
    y2: 14.0545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9308_7436",
    x1: 12.8039,
    y1: 9.61304,
    x2: 8.57903,
    y2: 9.74964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9308_7436",
    x1: 9.88378,
    y1: 9.36796,
    x2: 12.3278,
    y2: 12.3697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9308_7436",
    x1: 15.8356,
    y1: 5.10518,
    x2: 12.2931,
    y2: 5.21598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9308_7436",
    x1: 13.3873,
    y1: 4.89277,
    x2: 15.5186,
    y2: 7.42505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficientSupportTools);
export default __webpack_public_path__ + "static/media/efficientSupportTools.19613330df245b16003fc6a1b0c0c93e.svg";
export { ForwardRef as ReactComponent };